import { format } from "date-fns";
import { ru } from "date-fns/locale";

export const getDateFormatted = (startDate: Date, endDate: Date) => {
  return `${format(startDate, "MMM d, yyyy", { locale: ru })} - ${format(endDate, "MMM d, yyyy", { locale: ru })}`;
};
